<template>
  <div class="wl-certificate-student">
    <div class="certificate-student-content clearfix">
      <div class="wl-sidebar-menu">
        <div class="wl-lecturer-back clearfix" :style="{backgroundImage: 'url(' + (back) + ')'}">
          <div class="menu-sp-text">S</div>
          <div class="menu-sp-left">
            <p class="p-text-tea">学习资料</p>
            <p class="p-text-ecturer">OURCE</p>
          </div>
        </div>
        <div class="site-menu-ul clearfix">
          <div class="site-menu-con" v-for="(item,index) in certifySiteMenu" :key="index">
            <div
              class="clearfix site-menu-li"
              :class="{menuActive : menuActiveName == item.name}"
              @click="tabParentMenu(item.name,item.childMenu ? item.childMenu[0] : '')"
            >
              {{item.name}}
              <span class="wl-icon-xiangyou" :class="{'rotate' : item.childMenu}"></span>
            </div>
            <div
              v-for="(citem,index) in item.childMenu"
              :key="index"
              class="clearfix site-menu-li site-menu-child-li"
              :class="{menuActive : cildActiveName == citem}"
              @click="tabChildMenu(item.name,citem,index)"
            >
              <i class="wl-icon-dian"></i>
              {{citem}}
            </div>
          </div>
        </div>
      </div>
      <div class="wl-flow-content">
        <div class="authen-hade-title clearfix">
          <h3 class="h3-text-title">
            <span v-if="cildActiveName != ''">{{cildActiveName}}</span>
            <span v-else>{{menuActiveName}}</span>
          </h3>
          <div class="authen-hade-crumbs">
            <i class="wl-icon-zhuye1"></i>
            <span>当前位置：</span>
            <span @click="goHome">网站首页</span>
            <span>></span>
            <span @click="goSource" v-if="cildActiveName != ''">{{cildActiveName}}</span>
            <span v-else>{{menuActiveName}}</span>
            <span v-if="!isDetail">
              <span>></span>
              <span>{{title}}</span>
            </span>
            <span v-if="!isShowDetail">
              <span>></span>
              <span>{{activeTitle}}</span>
            </span>
          </div>
        </div>
        <div class="flow-text-content">
          <div class="stu-learning-resource" v-show="menuActiveName == '学习资料'">
            <div class="teaching-material-list clearfix" v-show="isDetail">
              <div
                class="teaching-resource-li lf clearfix"
                v-for="(item,index) in LearningMaterialList"
                :key="index"
                @click="goDetail(item.id,item.title)"
              >
                <div class="resource-img lf">
                  <img :src="item.cover || defaultCover" alt>
                </div>
                <div class="resource-book-info lf">
                  <p class="resource-book-name">{{item.title}}</p>
                  <p>作者：{{item.autor}}</p>
                  <p>适用对象：{{item.suitable}}</p>
                  <p class="p-chapter-text">简介：</p>
                  <p class="p-chapter-content">{{item.description}}</p>
                </div>
              </div>
            </div>
            <sourseDetail v-if="!isDetail" :sourseId="sourseId"></sourseDetail>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sourseDetail from "page/component/school/studySource.vue";
import activeDetail from "page/component/school/activeDetail.vue";
import { MU_UPATE_AUTH } from "store/index";
import redirect from "api/v1.commom.login.ts";
import CryptoJS from "crypto-js";
export default {
  created() {
    this.getLearningMaterialList();
  },
  components: {
    sourseDetail,
    activeDetail
  },
  data() {
    return {
      title: "",
      sourseId: "",
      isDetail: true,
      back: require("assets/images/bg-zl.png"),
      defaultCover: require("assets/images/new-course-cover.jpg"),
      menuActiveName: "学习资料",
      cildActiveName: "初级物流师资料",
      gradeRole: "初级物流师资料",
      competenceStandard: ["初级物流师", "中级物流师", "高级物流师"],
      certifySiteMenu: [
        {
          name: "学习资料",
          childMenu: ["初级物流师资料", "中级物流师资料", "高级物流师资料"]
        }
      ],
      input: "",
      activeId: "",
      activeTitle: "",
      isShowDetail: true,
      type: 3,
      siteName: "",
      LearningMaterialList: [],
      standardIndex: 0,
      levelType: 1,
      stuName: "",
      stuNumber: "",
      stuCover: "",
      show: 0,
      // 登录
      isShow: false
    };
  },
  computed: {
    association: function() {
      return this.$store.state.association;
    },
    userInfo() {
      return this.$store.state.auth;
    }
  },
  methods: {
    goHome() {
      this.$router.push({
        name: "xHome"
      });
    },
    goSource() {
      this.isDetail = true;
      this.isShowDetail = true;
    },
    goDetail(id, title) {
      this.isDetail = false;
      this.title = title;
      this.sourseId = id;
    },
    tabParentMenu(name, childMenu) {
      this.menuActiveName = name;
      this.cildActiveName = childMenu;
      this.isDetail = true;
      this.isShowDetail = true;
    },
    tabChildMenu(name, citem, index) {
      this.isDetail = true;
      this.isShowDetail = true;
      this.menuActiveName = name;
      this.cildActiveName = citem;
      this.standardIndex = index;
      (this.siteName = ""),
        (this.stuName = ""),
        (this.stuNumber = ""),
        (this.stuCover = ""),
        (this.gradeRole = this.competenceStandard[index]);
      if (citem == "初级物流师资料") {
        this.levelType = 1;
        this.getLearningMaterialList();
      } else if (citem == "中级物流师资料") {
        this.levelType = 2;
        this.getLearningMaterialList();
      } else if (citem == "高级物流师资料") {
        this.levelType = 3;
        this.getLearningMaterialList();
      }
    },
    //获取学习资料
    getLearningMaterialList() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationIndex/getLearningMaterialList", {
          associationId: that.association.Id,
          levelType: that.levelType
        })
        .then(rst => {
          if (rst.code == 1) {
            that.LearningMaterialList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>
